
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/communities/[community]",
      function () {
        return require("private-next-pages/communities/[community].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/communities/[community]"])
      });
    }
  